import { createRouter, createWebHistory } from 'vue-router'
import { abortAllRequests } from './api'
import AuthView from './views/AuthView.vue'
import NotFoundView from './views/NotFoundView.vue'
import { useSystemStore } from './stores/system'
import { useErrorStore } from './stores/error'
import qs from 'qs'
import dynamicTitles from './dynamicTitles'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (from.path === to.path) {
      return
    }

    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  parseQuery(query) {
    return qs.parse(query, {
      decoder(str, defaultDecoder, charset, type) {
        if (type === 'value') {
          // Boolean
          if (['true', 'false'].includes(str)) {
            return str === 'true'
          }

          // Numeric
          if (str && !isNaN(str)) {
            return parseFloat(str)
          }

          if (str === '') {
            return null
          }
        }

        return defaultDecoder(str)
      },
      comma: true,
      allowDots: true
    })
  },
  stringifyQuery(query) {
    const newQuery = qs.stringify(query, {
      encodeValuesOnly: true,
      arrayFormat: 'comma',
      skipNulls: true,
      allowDots: true
    })
    if (newQuery) {
      window.history.replaceState(window.history.state, '', `?${newQuery}`)
    }
    return newQuery
  },
  routes: [
    {
      path: '/',
      name: 'dashboard',
      redirect: '/offices'
    },
    {
      path: '/oauth/login',
      name: 'unauthorized',
      component: AuthView
    },
    {
      path: '/my-account',
      name: 'my-account',
      component: () => import('@/views/MyAccountView.vue')
    },
    {
      path: '/:notfound(.*)*',
      name: 'notfound',
      component: NotFoundView
    }
  ]
})

router.beforeEach(async (to, from /*next*/) => {
  if (from.name === to.name) {
    return
  }

  const systemStore = useSystemStore()
  const hubName = 'Nurtur Admin Hub'

  for (let i = 0; i < systemStore.confirmExitMethods.length; i++) {
    if (typeof systemStore.confirmExitMethods[i] === 'function' && !systemStore.confirmExitMethods[i](to)) {
      return false
    }
  }

  document.title = to.meta?.name
    ? `${to.meta.name.replace(/{{([A-z]+)}}/g, (m, p1) => to.params[p1] || '')} - ${hubName}`
    : hubName

  systemStore.setPreviousRoute({
    name: from?.name,
    path: router.resolve({
      name: from?.name,
      params: from ? { ...from.params } : null,
      query: from ? { ...from.query } : null
    })?.fullPath
  })
  await abortAllRequests()
})

router.afterEach((to) => {
  const errorStore = useErrorStore()
  errorStore.clearHttpError()

  if (to.name !== 'notfound') {
    dynamicTitles.set(to.path, to.params)
  }
})

export default router
